import { Link as ReactRouterLink } from 'react-router-dom';
import { Link as ChakraLink, LinkProps } from '@chakra-ui/react';

export function Link(props: LinkProps & { to?: string }) {
  return (
    <ChakraLink
      as={typeof props.to === 'string' ? ReactRouterLink : undefined}
      textDecoration={'none'}
      tabIndex={0}
      {...props}
    />
  );
}
